// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"f487ebc8","275":"5f59f941","453":"92fcf729","903":"be681dbc"}[chunkId] + ".chunk.js";
};